import api from './reducer'

export let {
  useLazyGetSpecialsQuery,
  useGetAddressSuggestionsMutation,
  useSetAddressMutation,
  useGetCategoryListQuery,
  useLazyGetCategoryListQuery,
  useGetProductListQuery,
  useGetAnonTokenQuery,
  useGetEntitySuggestionsMutation,
  useGetCartQuery,
  useGetCartIntervalsQuery,
  useLazyGetCartIntervalsQuery,
  useLazyGetMenusQuery,
  useGetPageQuery,
  useAddCartItemMutation,
  useUpdateCartItemMutation,
  useRemoveCartItemMutation,
  useAddCouponMutation,
  useRemoveCouponMutation,
  useGetBannersQuery,
  useLazyGetBannersQuery,
  useGetCitiesQuery,
  useLazyGetLocationQuery,
  useGetUserInfoQuery,
  useLazyGetUserInfoQuery,
  useSendSmsMutation,
  useCheckCodeMutation,
  useRegisterWithCodeMutation,
  useMaxLoginMutation,
  useLazyGetCartQuery,
  useSetPaymentMethodMutation,
  useCreateOrderMutation,
  useAddAddressMutation,
  useGetOrdersQuery,
  useUpdateAddressMutation,
  useLogoutMutation,
  useRemoveAddressMutation,
  useGetOrderQuery,
  useReOrderMutation,
  useClearCartMutation,
  useLazyGetProductListQuery,
  useSaveSettingsMutation,
  useConfirmEmailMutation,
  useDeleteProfileMutation,
  useSetDeliveryDateMutation,
  useVerifyEmailMutation,
  useSendServiceFormMutation,
  useGetCartActionsQuery,
  useSelectGiftsMutation,
  useGetAboutQuery,
  useLazyGetAboutQuery,
  useGetProductDetailQuery,
  useSetUniqueIdMutation,
  useSendPartnerFormMutation,
  useSendCallbackFormMutation,
  useGetSiteInfoQuery,
  useUpdateActionsMutation,
  useGetDateQuery,
  useLazyInitSpbPaymentQuery,
  useLazyGetSbpPaymentStatusQuery,
  useCreateFastOrderMutation,
  useChangeAddressModalMutation,
  useGetUserCartQuery,
  useLazyGetUserCartQuery,
} = api
